$.fn.isInViewport = function() {var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();
    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();
    return elementBottom > viewportTop && elementTop < viewportBottom;
};


//////////////////
// WEBPACK FOOTER
// ./static/js/vendor/isInViewport.js
// module id = 6
// module chunks = 0